import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "content"
};
const _hoisted_2 = {
  class: "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  const _component_SpuInfo = _resolveComponent("SpuInfo");
  const _component_el_tab_pane = _resolveComponent("el-tab-pane");
  const _component_H5Details = _resolveComponent("H5Details");
  const _component_PcDetails = _resolveComponent("PcDetails");
  const _component_SkuComponents = _resolveComponent("SkuComponents");
  const _component_el_tabs = _resolveComponent("el-tabs");
  const _component_DragDialog = _resolveComponent("DragDialog");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_el_main = _resolveComponent("el-main");
  return _openBlock(), _createBlock(_component_el_main, {
    class: "wrap_box bg_white"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_row, {
      class: "title_box head_box"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 24
      }, {
        default: _withCtx(() => [_ctx.data.isShowBtn == 1 ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "primary",
          disabled: _ctx.data.isClick,
          onClick: _cache[0] || (_cache[0] = $event => _ctx.stagingClick('staging'))
        }, {
          default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode(" 暂存")])),
          _: 1,
          __: [7]
        }, 8, ["disabled"])) : _createCommentVNode("", true), _createVNode(_component_el_button, {
          type: "primary",
          disabled: _ctx.data.isClick,
          onClick: _cache[1] || (_cache[1] = $event => _ctx.stagingSaveClickCom('save'))
        }, {
          default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode("保存")])),
          _: 1,
          __: [8]
        }, 8, ["disabled"])]),
        _: 1
      })]),
      _: 1
    }), _createElementVNode("div", _hoisted_1, [_createVNode(_component_el_tabs, {
      "model-value": _ctx.data.tabName,
      type: "card",
      class: "demo-tabs",
      onTabClick: _ctx.tabsChange
    }, {
      default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
        label: "SPU信息",
        name: "spuInfoM"
      }, {
        default: _withCtx(() => [(_openBlock(), _createBlock(_component_SpuInfo, {
          onTransmitAddSpuInfo: _ctx.transmitAddSpuInfo,
          key: _ctx.data.spuInfoRefresh
        }, null, 8, ["onTransmitAddSpuInfo"]))]),
        _: 1
      }), _createVNode(_component_el_tab_pane, {
        label: "PC详情",
        name: "pcDetails"
      }, {
        default: _withCtx(() => [(_openBlock(), _createBlock(_component_H5Details, {
          onTransmitH5: _ctx.transmitH5,
          key: _ctx.data.spuInfoRefresh
        }, null, 8, ["onTransmitH5"]))]),
        _: 1
      }), _createVNode(_component_el_tab_pane, {
        label: "H5/移动端详情",
        name: "h5Details"
      }, {
        default: _withCtx(() => [(_openBlock(), _createBlock(_component_PcDetails, {
          onTransmitPc: _ctx.transmitPc,
          key: _ctx.data.spuInfoRefresh
        }, null, 8, ["onTransmitPc"]))]),
        _: 1
      }), _createVNode(_component_el_tab_pane, {
        label: "SKU",
        name: "skuShow"
      }, {
        default: _withCtx(() => [(_openBlock(), _createBlock(_component_SkuComponents, {
          saveData: _ctx.data.newData,
          "onUpdate:saveData": _cache[2] || (_cache[2] = $event => _ctx.data.newData = $event),
          notice: _ctx.data.noticeSku,
          "onUpdate:notice": _cache[3] || (_cache[3] = $event => _ctx.data.noticeSku = $event),
          onTransmitTableInfo: _ctx.transmitTableInfo,
          key: _ctx.data.spuInfoRefresh
        }, null, 8, ["saveData", "notice", "onTransmitTableInfo"]))]),
        _: 1
      })]),
      _: 1
    }, 8, ["model-value", "onTabClick"])]), _ctx.data.dragDialogShow ? (_openBlock(), _createBlock(_component_DragDialog, {
      key: 0,
      isShow: _ctx.data.dragDialogShow,
      "onUpdate:isShow": _cache[4] || (_cache[4] = $event => _ctx.data.dragDialogShow = $event),
      onGetIfClose: _ctx.getIfClose,
      onIsSureClosePage: _ctx.isSureClosePage
    }, null, 8, ["isShow", "onGetIfClose", "onIsSureClosePage"])) : _createCommentVNode("", true), _createVNode(_component_el_dialog, {
      "model-value": _ctx.data.isShowStaging,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "show-close": false,
      title: "暂存数据",
      width: "440px",
      center: ""
    }, {
      footer: _withCtx(() => [_createElementVNode("span", _hoisted_2, [_createVNode(_component_el_button, {
        onClick: _cache[5] || (_cache[5] = $event => _ctx.stagingCommon('cancel'))
      }, {
        default: _withCtx(() => _cache[9] || (_cache[9] = [_createTextVNode("取消")])),
        _: 1,
        __: [9]
      }), _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[6] || (_cache[6] = $event => _ctx.stagingCommon('sure'))
      }, {
        default: _withCtx(() => _cache[10] || (_cache[10] = [_createTextVNode("确定")])),
        _: 1,
        __: [10]
      })])]),
      default: _withCtx(() => [_cache[11] || (_cache[11] = _createElementVNode("span", null, _toDisplayString('所有暂存数据都是临时数据无法被引用也无法同步至ERP，是否暂存？'), -1))]),
      _: 1,
      __: [11]
    }, 8, ["model-value"])]),
    _: 1
  });
}